import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RoboadvChatComponent } from './roboadv-chat/roboadv-chat.component';
import {FormsModule} from "@angular/forms";
import { MemoContentComponent } from './memo-content/memo-content.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSliderModule} from "@angular/material/slider";
import {HttpClientModule} from "@angular/common/http";
import {MatSelectModule} from "@angular/material/select";
import { NgxMaskModule } from "ngx-mask";
import {NgxUsefulSwiperModule} from "ngx-useful-swiper";
import { HomeComponent } from './home/home.component';
import { ThxComponent } from './thx/thx.component';
import {MatInputModule} from "@angular/material/input";
import { SocialShareDirective } from './_commons/social-share.directive';
import { Err404Component } from './err404/err404.component';
import { ErrAllComponent } from './err-all/err-all.component';
import { RaProgressBodyComponent } from './ra-progress-body/ra-progress-body.component';
import { SurveyComponent } from './survey/survey.component';
import { RaProgressBtnComponent } from './ra-progress-btn/ra-progress-btn.component';

@NgModule({
  declarations: [
    AppComponent,
    RoboadvChatComponent,
    MemoContentComponent,
    HomeComponent,
    ThxComponent,
    SocialShareDirective,
    Err404Component,
    ErrAllComponent,
    RaProgressBodyComponent,
    SurveyComponent,
    RaProgressBtnComponent,
  ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        BrowserAnimationsModule,
        MatSliderModule,
        MatSelectModule,
        NgxMaskModule.forRoot(),
        NgxUsefulSwiperModule,
        MatInputModule,
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
